import React, { useState } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import "./LanguageSelector.css";

let langData = require("../../../Data/language.json");

export default function LanguageSelector(props) {
  const [value, setValue] = useState(props.language);

  const handleChange = (event) => {
    setValue(event.target.value);
    props.updateLanguage(event.target.value);
  };

  return (
    <div className="row languageRow">
      <div className="container-fluid col-10 languageContainer">
        <FormControl
          component="fieldset"
          className="formControl languageContainer"
          defaultValue={value}
        >
          <FormHelperText style={{ textAlign: "center" }}>
            {langData[props.language].profile.languageHelper}
          </FormHelperText>
          <RadioGroup
            aria-label="Language"
            name="Language"
            className="languageSwitches"
            value={value}
            onChange={handleChange}
            row={true}
          >
            <FormControlLabel
              value="english"
              control={<Radio color="primary" />}
              label={langData[props.language].profile.english}
              labelPlacement="end"
            />
            <FormControlLabel
              value="swedish"
              control={<Radio color="primary" />}
              label={langData[props.language].profile.swedish}
              labelPlacement="end"
            />
          </RadioGroup>
        </FormControl>
      </div>
    </div>
  );
}
